/**
 * Custom Progress Component
 * Extends Ant Design Progress with custom styling
 */

import { Progress as AntProgress, ProgressProps } from 'antd';
import classNames from 'classnames';
import './CustomProgress.scss';

export interface CustomProgressProps extends ProgressProps {
  /** Progress variant */
  variant?: 'default' | 'gradient' | 'striped';
}

/**
 * CustomProgress Component
 */
export const CustomProgress: React.FC<CustomProgressProps> = ({
  variant = 'default',
  className,
  ...rest
}) => {
  const progressClasses = classNames('custom-progress', `custom-progress--${variant}`, className);

  return <AntProgress {...rest} className={progressClasses} />;
};

export default CustomProgress;

